

<!-- Admin Login Header -->
<section id="admin-login-page">
<dx-admin-header [logoHref]="undefined" />

<div [hidden]="loginCompleting">
  @if(dataReady && !loginCompleting){
    <cudc-ea-authenticate class="bl-margin-x--auto"
    [widgetContext]="widgetContext"
    (widgetExportDataChange)="receivedDataHandler($event)"/>
  }
</div>

@if(loginCompleting){
<div
  class="message-container bl-bg-color--white bl-border-radius--16 bl-padding--48 bl-padding-x-sm--24">
  <i class="loader bl-margin-x--auto bl-margin-bottom--24"></i>
  <p class="bl-text-style--display-6 bl-margin-bottom--0 bl-text-align--center">Retrieving your permissions...</p>
</div>
}
</section>